import React, {Component} from 'react'
import {GatsbyImage, getImage} from 'gatsby-plugin-image'
import parse from 'html-react-parser'
import Link from '../utils/link'
import CircleArrow from '../assets/images/arrow-circle.png'
import CurvedArrow from '../assets/images/arrow-04.png'
import LeftCurvedArrow from '../assets/images/left-curved-arrow.png'
import ZigZagArrow from '../assets/images/arrow-06.png'
import PercentageArrow from '../assets/images/percentage-arrow.png'
import {ArrowThickRight} from "./icons";
import Fade from "react-reveal/Fade";

class ImageTitleContent extends Component {

  render() {

    let {image, subtitle, title, content, button, reverse, icon, buttonColour, circleButton, h1, signature} = this.props

    return (
      <section className={`itc${reverse ? ' itc--reverse' : ''} ${signature ? ' itc--signature' : ''}`}>
        <Fade bottom distance='40px'>
          <div className='itc__inner'>
            <div className='itc__image'>
              <div className='itc__image-wrapper'>
                <GatsbyImage loading='lazy' image={getImage(image?.localFile)} alt={title}/>
                {icon === 'circle_arrow' && <img className='arrow arrow-1' loading='lazy' src={CircleArrow} alt="Arrow"/>}
                {icon === 'curved_arrow' && <img className='arrow arrow-2' loading='lazy' src={CurvedArrow} alt="Arrow"/>}
                {icon === 'left_curved_arrow' && <img className='arrow arrow-3' loading='lazy' src={LeftCurvedArrow} alt="Arrow"/>}
                {icon === 'zig_zag_arrow' && <img className='arrow arrow-4' loading='lazy' src={ZigZagArrow} alt="Arrow"/>}
                {icon === 'percentage_arrow' && <img className='arrow arrow-5' loading='lazy' src={PercentageArrow} alt="Arrow"/>}
              </div>
            </div>
            <div className='itc__content'>
              {subtitle && <span className='itc__subtitle'>{parse(subtitle)}</span>}
              {title && !h1 && <h3>{parse(title)}</h3>}
              {title && h1 && <h1>{parse(title)}</h1>}
              {content && <div>{parse(content)}</div>}
              {button?.url && !circleButton &&
                <Link to={button.url} className={`btn btn--${buttonColour}`}>{button.title}</Link>
              }
              {button?.url && circleButton &&
                <Link to={button.url} className='btn btn--circle'>
                  {button.title} <span className={`btn--${buttonColour}`}><ArrowThickRight/></span>
                </Link>
              }
              {
                signature &&
                <div className='itc__signature'>
                  <h4>Jo</h4>
                  <div>
                    <span>Jo Attard</span>
                    <span>Heart Financial Founder & Director</span>
                  </div>
                </div>
              }
            </div>
          </div>
        </Fade>
      </section>
    )
  }
}

export default ImageTitleContent